import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { BreadCrumb } from '../models/bread-crumb.Model';

@Injectable({
  providedIn: 'root'
})
export class SubNavStateService {

  constructor() { }

  breadCrumbList: BreadCrumb[] = new Array<BreadCrumb>();
  breadCrumbListSbj: Subject<BreadCrumb[]> = new Subject<BreadCrumb[]>();
  breadCrumbListStream = this.breadCrumbListSbj.asObservable();

  addBreadCrumb(newBreadCrumb: BreadCrumb) {

    if(!this.breadCrumbList || this.breadCrumbList.length == 0)
    {
      if(this.breadCrumbList)
      {
        this.breadCrumbList.push(newBreadCrumb);
      }
      else{
        this.breadCrumbList = [newBreadCrumb];
      }
      this.breadCrumbListSbj.next(this.breadCrumbList);
    }
    else{
      this.breadCrumbList.forEach(existingBreadCrumb => {
        let existsPath = existingBreadCrumb.routerLinkArray.filter(existingLink => newBreadCrumb.routerLinkArray.includes(existingLink));
        if (!existsPath) {
          this.breadCrumbList.push(newBreadCrumb);
          this.breadCrumbListSbj.next(this.breadCrumbList);
          return;
        }
      });
    }
    

    // this.breadCrumbList.forEach(existingBreadCrumb => {
    //   if(existingBreadCrumb.routerLinkArray.includes(existingLink => {}))
    //  });

    // if(newBreadCrumb.routerLinkArray.includes(newLink=> this.breadCrumbList.includes))

    // this.breadCrumbList.forEach(existingBreadCrumb => {
    //   if(existingBreadCrumb.routerLinkArray.in)

    // existingBreadCrumb.routerLinkArray.forEach(linkPath => {

    // })
    // })





  }
}




// if (this.breadCrumbList.some(function(breadCrumb) {
//   breadCrumb.routerLinkArray.forEach(element => {

//     if (newBreadCrumb.routerLinkArray.find(newRouterLink => newRouterLink == element)) {
//       return true;
//     }

//     else {
//       this.breadCrumbList.push(newBreadCrumb);
//       this.breadCrumbListSbj.next(this.breadCrumbList);
//     }

//   })
// })) {

// }
